import { render, staticRenderFns } from "./collection-hotkey.vue?vue&type=template&id=6d85aa42&scoped=true"
import script from "./collection-hotkey.vue?vue&type=script&lang=ts"
export * from "./collection-hotkey.vue?vue&type=script&lang=ts"
import style0 from "./collection-hotkey.vue?vue&type=style&index=0&id=6d85aa42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d85aa42",
  null
  
)

export default component.exports